import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function register(data) {
  return request({
    url: '/auth/register',
    method: 'post',
    data
  })
}

export function checkUsername(username) {
  return request({
    url: '/auth/check-username',
    method: 'get',
    params: { username }
  })
}

export function getCurrentUser() {
  return request({
    url: '/auth/currentUser',
    method: 'get'
  })
}

export function getCaptcha(oldCaptchaKey) {
  return request({
    url: '/auth/captcha',
    method: 'get',
    params: { oldCaptchaKey: oldCaptchaKey || '' }
  })
}

export function logout() {
  return Promise.resolve()
}
